import moment from 'moment';

export function getTime(postdate) {
	let timeformat = "Just now";
	let now = moment();
	let end = moment(postdate);
	let duration = moment.duration(now.diff(end));
	var days = duration.days();
	var hours = duration.hours();
	var minutes = duration.minutes();
	var seconds = duration.seconds();
	if (days) {
		timeformat = end.format("MMMM D , h:mm A"); 
	} else if (hours) {
		timeformat = end.format('LT');
	} else if (minutes) {
		timeformat = end.format('LT');
	} else if (seconds) {
		timeformat = end.format('LT');
	}

	return timeformat;
}
